export default "__VITE_ASSET___SfMEmE___"